import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'

import axios from './config/http'
import { baseUrl } from './config/env'
import './assets/less/main.less'

import iView from 'iview'
import 'iview/dist/styles/iview.css'
import $ from 'jquery'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/dist/css/swiper.css'

import VueMeta from 'vue-meta'

import { getToken } from './utils/auth'

Vue.use(iView)
Vue.use(ElementUI)
Vue.use(VueMeta)

Vue.prototype.domainNameH5 = baseUrl

Vue.prototype.$http = axios

// 截取字符串
Vue.prototype.cutString = (str, length) => {
  if (str.length <= length) {
    return str
  } else {
    return str.substr(0, length) + '…'
  }
}

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  if (getToken('userId')) {
    store.commit('SET_USERID', getToken('userId'))
    store.commit('SET_USER', getToken('username'))
    next()
  } else {
    next()
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.jquery = window.$ = $
